import PropTypes from 'prop-types';
// material
import { useTheme, styled } from '@mui/material/styles';
import {MIconButton} from '../../@mui-extend';
//
import Iconify from '../../iconify';

// ----------------------------------------------------------------------

const SIZE = 40;

const RootStyle = styled('div')(({ theme }) => ({
  top: 0,
  bottom: 0,
  zIndex: 9,
  height: SIZE,
  width: '100%',
  margin: 'auto',
  display: 'flex',
  position: 'absolute',
  padding: theme.spacing(0, 2),
  justifyContent: 'space-between'
}));

const ArrowStyle = styled(MIconButton)(({ theme }) => ({
  width: SIZE,
  height: SIZE,
  opacity: 0.48,
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
  background: theme.palette.grey[900],
  borderRadius: theme.shape.borderRadiusSm,
  transition: theme.transitions.create('opacity'),
  '&:hover': {
    opacity: 1,
    background: theme.palette.grey[900]
  }
}));

// ----------------------------------------------------------------------

CarouselControlsArrowsBasic2.propTypes = {
  onNext: PropTypes.func,
  onPrevious: PropTypes.func
};

export default function CarouselControlsArrowsBasic2({
  onNext,
  onPrevious,
  ...other
}) {
  const theme = useTheme();
  const isRTL = theme.direction === 'rtl';

  return (
    <RootStyle {...other}>
      <ArrowStyle size="small" onClick={onPrevious}>
      <Iconify icon={isRTL ? 'eva:arrow-right-fill': 'eva:arrow-left-fill'} sx={{ width: 20, height: 20, mr: 0.5 }} />
      
      </ArrowStyle>

      <ArrowStyle size="small" onClick={onNext}>
      <Iconify icon={isRTL ? 'eva:arrow-left-fill':'eva:arrow-right-fill'} sx={{ width: 20, height: 20, mr: 0.5 }} />
       
      </ArrowStyle>
    </RootStyle>
  );
}
